/*
 * Functions to produce empty layers (filled with default properties)
 * for each layer type.
 */
import shortid from 'shortid';
import directions from '@/shared/directions';

export default {
  /**
   * Creates a base layer. Used when new text- or foto-layers are created
   * in kartendesigner
   */
  getBaseLayer() {
    return {
      id: shortid.generate(),
      x: 25, // % of card with
      y: 25, // % of card height
      width: 50, // % of card width
      height: 50, // % of card height
    };
  },

  /**
   * Initializes a text-layer / sets all default values for new text layer.
   * @param layer {Object} - The base layer-object
   * @returns {Object} Clone of the input layer with new properties
   */
  initTextLayer(layer) {
    const textLayer = JSON.parse(JSON.stringify(layer));
    textLayer.type = 'text';
    textLayer.text = 'Ihr Text hier';
    textLayer.fontSize = 14;
    textLayer.fontWeight = 400;
    textLayer.fontStyle = 'normal';
    textLayer.fontName = '';
    textLayer.lineHeight = 1.2;
    // should be documented that all measurements are in pt, mm or %
    // textLayer.fontSizeUnit = 'pt';
    textLayer.color = '#000000';
    textLayer.alignmentX = directions.CENTER;
    textLayer.alignmentY = directions.CENTER;
    return textLayer;
  },

  /**
   * Initiates a photo layer, makes sure all properties are set.
   * @param {Object} layer - The photo layer to initiate
   * @returns {Object} Clone of the input layer with new properties
   */
  initFotoLayer(layer) {
    const fotoLayer = JSON.parse(JSON.stringify(layer));
    fotoLayer.type = 'foto';
    fotoLayer.imageUrl = '';
    return fotoLayer;
  },

  /**
   * Initiates a graphic layer, makes sure all properties are set.
   * @param {Object} layer - The graphic layer to initiate
   * @returns {Object} Clone of the input layer with new properties
   */
  initGrafikLayer(layer) {
    const grafikLayer = JSON.parse(JSON.stringify(layer));
    grafikLayer.type = 'grafik';
    grafikLayer.imageUrl = '';
    // grafikLayer.width = 0;
    // grafikLayer.height = 0;
    // grafikLayer.x = 0;
    // grafikLayer.y = 0;
    return grafikLayer;
  },

  /*
  * Shop URL text on the right (text rotated)
  * |---------------------|
  * |                 |   |
  * |                 | * |
  * |                 | * |
  * |                 |   |
  * |---------------------|
  *
  * Shop URL text on the left (text rotated)
  * |---------------------|
  * |   |                 |
  * | * |                 |
  * | * |                 |
  * |   |                 |
  * |---------------------|
  *
  * Shop URL text on the bottom
  * |---------------------|
  * |                     |
  * |                     |
  * |---------------------|
  * |        * *          |
  * |---------------------|
  *
  */
  initUrlLayer(layer) {
    const urlLayer = JSON.parse(JSON.stringify(layer));
    urlLayer.type = 'url';
    const isVertical = urlLayer.height > urlLayer.width;
    let orientation;
    if (isVertical) {
      if (urlLayer.x > 50) { // layer starting at over 50% of overall width, so right side
        orientation = directions.RIGHT;
      } else {
        orientation = directions.LEFT;
      }
    } else { // horizontal
      orientation = directions.BOTTOM;
    }
    urlLayer.orientation = orientation;
    return urlLayer;
  },
};
